import * as React from 'react';
export const SvgFiletypeSketchup = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#e72b2d' }),
        React.createElement("path", { d: 'M9.292 4L4 4.692l.725 4.553 1.114 3.434 5.581-1.588.58-4.956zM5.95 10.448l-.297-.88 1.555-.336.442.804zM7.565 8.48l-.464-.771-1.71.35-.29-.824 3.136-.547 1.147 1.397zm1.852-1.89L8.205 5.354l-3.394.477-.257-.737L9.14 4.5l.778.613 1.456 1.13z', fill: '#fff' }),
        React.createElement("path", { d: 'M11 0l3 3h-3z', fill: '#a11e1f' })));
};
export default SvgFiletypeSketchup;
